<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Список адресов</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Добавить адрес</li>
        </ol>
    </nav>

    <div class="col-md-4 col-12">
        <div class="form-row mb-4">
            <div class="col-md-12">
                <label for="input_name_client_id">Клиент</label>
                <select id="input_name_client_id" v-model="picked_client" class="form-select">
                    <option disabled value="0">-------</option>
                    <option v-for="item in clients" :value="item.id">{{ item.name }}</option>
                </select>
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label for="client-org_id">Организация</label>
                <select id="client-org_id" v-model="formData.org_id" class="form-select">
                    <option disabled value="0">-------</option>
                    <option v-for="item in orgs" :value="item.id">{{ item.name }}</option>
                </select>
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label for="client-brand_id">Бренд</label>
                <select id="client-brand_id" v-model="formData.brand_id" class="form-select">
                    <option disabled value="0">-------</option>
                    <option v-for="item in brands" :value="item.id">{{ item.name }}</option>
                </select>
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label for="client-region_id">Регион</label>
                <select @change="onChangeRegionId()" id="client-region_id" v-model="formData.region_id" class="form-select">
                    <option disabled value="0">-------</option>
                    <option v-for="item in regions" :value="item.id">{{ item.name }}</option>
                </select>
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label for="client-city_id">Город</label>
                <select :disabled="formData.region_id === 0" id="client-city_id" v-model="formData.city_id" class="form-select">
                    <option disabled value="0">-------</option>
                    <option v-for="item in cities" :value="item.id">{{ item.name }}</option>
                </select>
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label for="client-repository_id">Репозиторий</label>
                <select id="client-repository_id" v-model="formData.repository_id" class="form-select">
                    <option disabled value="0">-------</option>
                    <option v-for="repository in repositories" :value="repository.id">{{ repository.repository_path }}</option>
                </select>
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label for="client-number">Номер</label>
                <input type="text" class="form-control" id="client-number" v-model="formData.number" placeholder="Введите номер">
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label for="client-street">Адрес</label>
                <input type="text" class="form-control" id="client-street" v-model="formData.street" placeholder="Введите адрес">
            </div>
        </div>


        <div class="form-row mb-4">
            <div class="col-md-12">
                <label for="client-house">Номер дома</label>
                <input type="text" class="form-control" id="client-house" v-model="formData.house" placeholder="Введите номер дома">
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label for="client-floor">Этаж</label>
                <input type="text" class="form-control" id="client-floor" v-model="formData.floor" placeholder="Введите этаж">
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label for="client-comment">Комментарий</label>
                <input type="text" class="form-control" id="client-comment" v-model="formData.comment" placeholder="Введите комментарий">
            </div>
        </div>

        <div class="d-flex w-50 align-items-center justify-content-start">
            <button class="btn btn-lg btn-primary me-3" v-on:click="createAddress()">
                Добавить
            </button>

            <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
        </div>
    </div>
</template>

<script>
import Address from "../../../../models/Address";

export default {
    name: "AddressCreateComponent",
    props: {
        route_back: String,
        route_client_search: String,
        route_organization_search: String,
        route_brand_search: String,
        route_region_search: String,
        route_city_search: String,
        route_repository_search: String,
        route_create: String
    },
    data: function () {
        return {
            address: new Address({
                route_client_search: this.route_client_search,
                route_create: this.route_create,
                route_organization_search: this.route_organization_search,
                route_brand_search: this.route_brand_search,
                route_region_search: this.route_region_search,
                route_city_search: this.route_city_search,
                route_repository_search: this.route_repository_search,
            }),
            clients: [],
            picked_client: 0,
            orgs: [],
            brands: [],
            regions: [],
            cities: [],
            repositories: [],
            formData: {
                'client_id': 0,
                'org_id': 0,
                'brand_id': 0,
                'region_id': 0,
                'city_id': 0,
                'metro_id': 0,
                'repository_id': 0,
                'number': '',
                'street': '',
                'house': 0,
                'floor': 0,
                'comment': '',
                'lon': 0.0,
                'lat': 0.0,
            }
        }
    },
    watch: {
        picked_client: function () {
            this.formData.client_id = this.picked_client;
            this.searchBrands();
            this.searchOrgs();
        }
    },
    methods: {
        createAddress: async function () {
            let result = await this.address.create(this.formData);
            if (result) {
                window.location.href = this.route_back;
            } else {
                console.log('error: create_brand');
            }
        },
        searchClients: async function () {
            let clients = await this.address.clients();
            this.clients = clients.items;
        },
        searchOrgs: async function() {
            let orgs = await this.address.organizations({
                client_id: this.formData.client_id
            });
            this.orgs = orgs.items;
        },
        searchBrands: async function() {
            let brands = await this.address.brands({
                client_id: this.formData.client_id
            });
            this.brands = brands.items;
        },
        searchRegions: async function() {
            let regions = await this.address.regions();
            this.regions = regions.items;
        },
        searchCities: async function() {
            let cities = await this.address.cities();
            this.cities = cities.items;
        },
        searchRepositories: async function() {
            let repositories = await this.address.repositories();
            this.repositories = repositories.items;
        },
        onChangeRegionId: async function () {
            const data = await axios.get(this.route_city_search, {
                params: {
                    page: 1,
                    limit: 1000,
                    region_id: this.formData.region_id
                }
            }).then(response => {
                return response.data
            });

            this.cities = data.status == "ok" ? data.items : [];
        }
    },
    mounted() {
        this.searchClients();
        this.searchOrgs();
        this.searchBrands();
        this.searchRegions();
        this.searchCities();
        this.searchRepositories();
    }
}
</script>

<style scoped>

</style>
